import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useQuery } from 'react-query';
import ForecastRentsUtilityAllowanceFormService from '../../../services/forecastRentsUtilityAllowanceFormService';

export const useProposedUtilityAllowanceValues = (control, floorPlanRows) => {
  const fieldNames = useMemo(
    () => floorPlanRows.map((row) => `${row.id}-proposedChange`),
    [floorPlanRows],
  );

  const values = useWatch({
    control,
    name: fieldNames,
  });

  return useMemo(
    () =>
      fieldNames.reduce((acc, current, index) => {
        acc[current] = values?.[index];

        return acc;
      }, {}),
    [fieldNames, values],
  );
};

export const useForecastRentsUtilityAllowanceFormQuery = (
  rentForecastId,
  callback,
) => {
  const service = useMemo(
    () => new ForecastRentsUtilityAllowanceFormService(),
    [],
  );
  const queryKey = [
    'useForecastRentsUtilityAllowanceFormQuery',
    rentForecastId,
  ];
  const { data, isFetching, refetch } = useQuery(
    queryKey,
    async () => {
      const forecastRentsUtilityAllowanceForm =
        await service.getForecastRentsUtilityAllowanceForm(rentForecastId);
      if (callback) {
        callback(forecastRentsUtilityAllowanceForm);
      }
      return forecastRentsUtilityAllowanceForm;
    },
    {
      enabled: Boolean(rentForecastId),
      staleTime: 0,
      cacheTime: 0,
    },
  );
  const results = useMemo(() => data ?? [], [data]);
  return {
    results,
    isFetching,
    refetch,
  };
};
